module.exports = __webpack_public_path__ + "assets/img/no-data-yh.774604ef.png";